import React, { FunctionComponent } from 'react';
import { Box } from '@mui/material';
import styles from './ChooseYourPlan.module.css';
import { NormalSubscriptionPlan, ProjectAlphaSubscriptionPlan } from '../../..';
import { logoutBbl } from '../../../../common/CommonTools';
import BblButton from '../../../../component/buttons/bblButton';
import { PlanCard } from '../../../../component/parentPortal/planCard/planCard';
import { MobileStepIndicator } from '../../../../component/signup/mobileStepIndicator/mobileStepIndicator';
import { useAppSelector } from '../../../../store/hooks';
import { selectAppStateData } from '../../../../store/reducer/appStateSlice';
import { ChoosePaymentMethod } from '../../choosePaymentMethod';
import { ChooseYourPlanElement } from '../ChooseYourPlanElement';

export const MobileView: FunctionComponent = (): JSX.Element => {
  // REDUX
  const appState = useAppSelector(selectAppStateData);

  // Page Element
  const chooseYourPlanElement = ChooseYourPlanElement();

  return (
    <React.Fragment>
      <header className={styles.commonHeaderGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
        <Box style={{ marginLeft: 'auto' }}>
          <BblButton color="primary" size="small" onClick={logoutBbl}>
            Log Out
          </BblButton>
        </Box>
      </header>
      <Box className={styles.mainGroupBox}>
        {chooseYourPlanElement.selectedPlan ? (
          <ChoosePaymentMethod
            selectedPlan={chooseYourPlanElement.selectedPlan}
            back={chooseYourPlanElement.resetSelectedPlan}
          />
        ) : (
          <>
            <Box className={styles.mainGroupTitleBox}>
              <span className={styles.mainGroupTitle}>Choose Your Plan</span>
            </Box>
            {/* <Box>
          <Box className={styles.mainGroupBoxDescription}>
            <img
              id="choose-your-plan-coupon-icon"
              alt=""
              src="assets/chooseYourPlan/choose-your-plan-coupon-icon.svg"
            />
            <span
              className={styles.mainGroupBoxDescriptionText}
            >{`You can add Promotion Code in the next step!`}</span>
          </Box>
        </Box> */}

            <Box className={styles.mainGroupCenter}>
              <img
                className={styles.projectAlphaIcon}
                id="entry-header"
                alt=""
                src="assets/common/project-alpha-logo.png"
              />
              {chooseYourPlanElement.planList.map((p, i) => {
                return <PlanCard {...p} key={`plan-${i}`} fullWidth />;
              })}
              <Box style={{ height: '60px', flexShrink: 0, width: '100%' }} />
            </Box>
            <footer className={styles.progressIndicatorsFooter}>
              <MobileStepIndicator totalStep={4} step={4} />
            </footer>
          </>
        )}
      </Box>
    </React.Fragment>
  );
};
